import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import * as angular from 'angular';

class TradingRestrictionsSettingsComponentCtrl implements ng.IController {
    private settings: TsoSecondarySettingsDto;
    private authenticatedUser: LoginResult;
    public timeUnits: any = ['HOUR', 'DAY', 'MONTH'];

    constructor(
        private growl: Growl,
        private errorHandler: ErrorHandler,
        private TransmissionSystemOperator: TransmissionSystemOperatorResource
    ) {}

    $onInit() {}

    public onSetMinimumTradeRuntime(progressiveInput): ng.IPromise<any> {
        return this.TransmissionSystemOperator.saveMinimumTradeRuntime(
            { id: this.authenticatedUser.referenceId },
            this.settings.minimumTradeRuntime,
            () => {
                if (!progressiveInput) {
                    this.growl.show('Successfully saved.', 'success', {
                        delay: 2000
                    });
                }
            },
            this.errorHandler
        ).$promise;
    }

    public;
    onAllowBundlingOfUnbundledContracts() {
        this.TransmissionSystemOperator.saveAllowBundlingOfUnbundledContracts(
            { id: this.authenticatedUser.referenceId },
            this.settings.allowBundlingOfUnbundledContracts,
            () => {
                this.growl.show('Successfully saved.', 'success', {
                    delay: 2000
                });
            },
            this.errorHandler
        );
    }
}

angular.module('app').component('pkpTradingRestrictionsSettings', {
    controller: TradingRestrictionsSettingsComponentCtrl,
    template:
        require('app/operator-settings-secondary-market/trading-restrictions-settings.component.html'),
    bindings: {
        settings: '=',
        authenticatedUser: '='
    }
});
